export default __webpack_public_path__ + "static/media/add-icon-gray.849311e7.svg";